import axiosInstance from '@/utils/api.js'

var state = {
  userContacts: []
}

var getters = {
  USER_CONTACTS: (state) => {
    return state.userContacts
  }
}

var mutations = {
  SET_USER_CONTACTS: (state, payload) => {
    state.userContacts = payload || []
  }
}

var actions = {
  GET_USER_CONTACTS: async (context, payload) => {
    let result = await axiosInstance.get('/users/contacts?user_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_USER_CONTACTS', result.data)
    }
  },
  CREATE_USER_CONTACTS: (context, payload) => {
    return axiosInstance.post('/users/contacts?user_id=' + payload.user_id, payload.contact)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/users/contacts.js